export const SET_ALL_NODES = 'SET_ALL_NODES';
export const SET_HOVERED_NODES = 'SET_HOVERED_NODES';
export const SET_ERROR_NODES = 'SET_ERROR_NODES';
export const SET_AUTHENTICATION = 'SET_AUTHENTICATION';
export const SET_ALL_EDGES = 'SET_ALL_EDGES';
export const SET_API_KEY = 'SET_API_KEY';
export const SET_CURRENT_PLAN = 'SET_CURRENT_PLAN';
